  export default {
    setTradeList(state, trades) {
      state.tradeList = trades;
    },
    setPositions(state, positions) {
      state.positions = positions;
    }
  };